import { makeStyles } from "@mui/styles";
import { Colors } from "../helpers/Colors";

export const Searchbar_useStyles = makeStyles({
  SearchBar: {
    "& .Container": {
      position: "relative",
      "& div": {
        "& input": {
          zIndex: 0,
          width: "270px",
          backgroundColor: Colors.white,
          outline: "none",
          borderRadius: "4px",
          border: `1px solid ${Colors.primary}`,
          padding: "5px 10px",
          // --------- from xs(380px) till md(770px)
          "@media only screen and (max-Width: 770px)": {
            width: "200px",
          },
        },
      },
      "& .iconCon": {
        position: "absolute",
        top: 6,
        right: 5,
        color: Colors.secondary,
        padding: "2px",
        backgroundColor: Colors.white,
        borderRadius: "25px",
        "& .icon": {
          width: "20px",
          height: "20px",
        },
        "& #closeIcon": {
          //  top: 10,
          width: "18px",
          height: "20px",
        },
      },
    },
  },
});
